module.exports = __webpack_public_path__ + "static/media/preview_banner.c4972b53.png";